import React, { Component } from 'react';
import './App.scss';
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import welcome from "./components/welcome"
import SignIn from "./components/sign-in-page";
import MainPage from "./components/main-page";
import NotFound from "./components/not-found";
import TermsAndConditions from "./components/terms-and-condition";
import ReviewStatus from "./components/review-status";
import SignOut from "./components/sign-out"


class App extends Component {

  render() {
      const stylesObj = {
          background: "ROSYBROWN"
      };

      return (
                  <Router>
          <Switch>
          <Route exact path='/' component={SignIn} />
      <Route exact path='/esig' component={SignIn} />
      <Route exact path='/sign_in' component={SignIn} />
      <Route exact path='/not_found' component={NotFound} />
      <Route exact path='/welcome' component={welcome} />
      <Route exact path='/main_page' component={MainPage} />
      <Route exact path='/review_status' component={ReviewStatus} />
      <Route exact path='/tnc' component={TermsAndConditions} />
      <Route exact path='/sign_out' component={SignOut} />

              SignOut
  </Switch>
  </Router>
    );
  }
}

export default App;
